module.exports = __webpack_public_path__ + "static/media/prev.d11d99bb.svg";